if (!window.cartRecommendationsInitialized) {
  window.cartRecommendationsInitialized = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.upsell-add');
    if (!button || button.disabled) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    const context = button.dataset.cartContext || 'drawer';
    const originalLabel = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!addResponse.ok) {
        const error = new Error('Unable to add recommendation');
        error.isStockError = addResponse.status === 422;
        throw error;
      }

      const itemsSectionId = document.getElementById('main-cart-items')?.dataset.id || 'main-cart-items';
      const footerSectionId = document.getElementById('main-cart-footer')?.dataset.id || 'main-cart-footer';
      const sectionNames =
        context === 'page'
          ? [itemsSectionId, footerSectionId, 'cart-icon-bubble']
          : ['cart-drawer', 'cart-icon-bubble'];
      const sectionsUrl = context === 'page' ? window.location.pathname : '/';
      const [sectionsResponse, cartResponse] = await Promise.all([
        fetch(`${sectionsUrl}?sections=${sectionNames.join(',')}`),
        fetch('/cart.js'),
      ]);

      if (!sectionsResponse.ok || !cartResponse.ok) {
        throw new Error('Unable to refresh cart');
      }

      const [sections, cartData] = await Promise.all([
        sectionsResponse.json(),
        cartResponse.json(),
      ]);
      const parser = new DOMParser();

      if (context === 'page') {
        replaceSectionContents(parser, sections, itemsSectionId, '#main-cart-items .js-contents');
        replaceSectionContents(parser, sections, footerSectionId, '#main-cart-footer .js-contents');
      } else {
        const currentDrawer = document.querySelector('cart-drawer');
        const updatedDrawer = parser
          .parseFromString(sections['cart-drawer'], 'text/html')
          .querySelector('cart-drawer');

        if (currentDrawer && updatedDrawer) {
          currentDrawer.classList.toggle('is-empty', updatedDrawer.classList.contains('is-empty'));
          currentDrawer.renderContents({ sections });
        }
      }

      replaceSectionContents(parser, sections, 'cart-icon-bubble', '#cart-icon-bubble');

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-recommendations',
          cartData,
          variantId,
        });
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
    } catch (error) {
      console.error(error);
      button.textContent = error.isStockError ? 'Sold out' : 'Try again';
      button.disabled = Boolean(error.isStockError);

      if (!error.isStockError) {
        window.setTimeout(() => {
          button.textContent = originalLabel;
          button.disabled = false;
        }, 2000);
      }
    }
  });
}

function replaceSectionContents(parser, sections, sectionName, selector) {
  const sectionHtml = sections[sectionName];
  if (!sectionHtml) return;

  const updatedElement = parser.parseFromString(sectionHtml, 'text/html').querySelector(selector);
  const currentElement = document.querySelector(selector);

  if (currentElement && updatedElement) currentElement.innerHTML = updatedElement.innerHTML;
}
